<template>
	<div>

		<h2>
			{{ $t('form-type-editor') }}
			<div class="float-right">
				<button @click="save" class="btn btn-primary">{{ $t('save') }}</button>
			</div>
		</h2>

		<div v-if="saved">
			<div class="alert alert-success mt-8">{{ $t('form-type-saved') }}</div>
		</div>

		<div class="form-group">
			<label for="formtype-title">{{ $t('title') }}</label>
			<input id="formtype-title" name="formtypetitle" class="form-control" v-model="formtype.title" :placeholder="$t('title')" required>
		</div>

		<div class="form-group">
			<label class="block">{{ $t('assessment-form-q') }}</label>
			<div class="btn-group block">
				<a class="btn" :class="{ 'btn-secondary': formtype.assessment == false, 'btn-success': formtype.assessment == true }" @click="formtype.assessment = true">{{ $t('yes') }}</a>
				<a class="btn" :class="{ 'btn-secondary': formtype.assessment == true, 'btn-success': formtype.assessment == false }" @click="formtype.assessment = false">{{ $t('no') }}</a>
			</div>
		</div>

		<div class="form-group">
			<label class="block">{{ $t('report-form-q') }}</label>
			<div class="btn-group block">
				<a class="btn" :class="{ 'btn-secondary': formtype.report == false, 'btn-success': formtype.report == true }" @click="formtype.report = true">{{ $t('yes') }}</a>
				<a class="btn" :class="{ 'btn-secondary': formtype.report == true, 'btn-success': formtype.report == false }" @click="formtype.report = false">{{ $t('no') }}</a>
			</div>
		</div>

		<div class="form-group">
			<label class="block">{{ $t('this-form-is-about-another-user') }}</label>
			<div class="btn-group block">
				<a class="btn" :class="{ 'btn-secondary': formtype.hassubject == false, 'btn-success': formtype.hassubject == true }" @click="formtype.hassubject = true">{{ $t('yes') }}</a>
				<a class="btn" :class="{ 'btn-secondary': formtype.hassubject == true, 'btn-success': formtype.hassubject == false }" @click="formtype.hassubject = false">{{ $t('no') }}</a>
			</div>
		</div>
		<div class="form-group" v-if="formtype.hassubject==true">
			<label class="block">{{ $t('visible-to-subject') }}</label>
			<div class="btn-group block">
				<a class="btn" v-for="option in visibletosubjectoptions" :key="option.value" :class="{ 'btn-secondary': formtype.visibletosubjectafter != option.value, 'btn-success': formtype.visibletosubjectafter == option.value }" @click="formtype.visibletosubjectafter = option.value">{{ option.caption }}</a>
			</div>
		</div>

		<div class="form-group">
			<label class="block">{{$t('require-review')}}</label>
			<div class="btn-group block">
				<a class="btn" :class="{ 'btn-secondary': formtype.requirereview == false, 'btn-success': formtype.requirereview == true }" @click="formtype.requirereview = true">{{ $t('yes') }}</a>
				<a class="btn" :class="{ 'btn-secondary': formtype.requirereview == true, 'btn-success': formtype.requirereview == false }" @click="formtype.requirereview = false">{{ $t('no') }}</a>
			</div>
		</div>

		<div class="form-group">
			<label class="block">{{$t('require-signoff')}}</label>
			<div class="btn-group block">
				<a class="btn" :class="{ 'btn-secondary': formtype.requiresignoff == false, 'btn-success': formtype.requiresignoff == true }" @click="formtype.requiresignoff = true">{{ $t('yes') }}</a>
				<a class="btn" :class="{ 'btn-secondary': formtype.requiresignoff == true, 'btn-success': formtype.requiresignoff == false }" @click="formtype.requiresignoff = false">{{ $t('no') }}</a>
			</div>
		</div>

		<div class="row">
			<div class="col-md-3">
				<b-form-group :label="$t('select-roles')">
					<b-form-checkbox-group
					v-model="formtype.roles.select"
					:options="roleoptions"
					stacked
					></b-form-checkbox-group>
				</b-form-group>
			</div>
			<div class="col-md-3" v-if="formtype.hassubject==true">
				<b-form-group :label="$t('subject-roles')">
					<b-form-checkbox-group
					v-model="formtype.roles.subject"
					:options="roleoptions"
					stacked
					></b-form-checkbox-group>
				</b-form-group>
			</div>
			<div class="col-md-3" v-if="formtype.requirereview==true">
				<b-form-group :label="$t('review-roles')">
					<b-form-checkbox-group
					v-model="formtype.roles.review"
					:options="roleoptions"
					stacked
					></b-form-checkbox-group>
				</b-form-group>
			</div>
			<div class="col-md-3">
				<b-form-group :label="$t('signoff-roles')">
					<b-form-checkbox-group
					v-model="formtype.roles.signoff"
					:options="roleoptions"
					stacked
					></b-form-checkbox-group>
				</b-form-group>
			</div>
		</div>
		<div class="row">
			<div class="col-md-3">
				<b-form-group :label="$t('programmes')">
					<b-form-checkbox-group
						stacked
					>
				    	<b-form-checkbox
				    	:value="programme.Id"
				    	:key="programme.Id"
				    	v-for="programme in $config.getValue('programmes')"
				    	v-model="formtype.programmes"
				    	>
				    	{{ programme.Name }}
						</b-form-checkbox>
					</b-form-checkbox-group>
				</b-form-group>
			</div>
		</div>

    </div>
</template>

<script>
export default {
	components: {
	},
    data: function() {
        return {
        	formtype_id: null,
        	formtype: {
        		title: this.$t('new-form-type'),
        		assessment: false,
        		report: false,
        		hassubject: false,
				requirereview: false,
        		requiresignoff: true,
        		visibletosubjectafter: 'never',
        		roles: {
        			select: [],
        			subject: [],
        			review: [],
        			signoff: []
        		},
        		programmes: []
        	},
        	saved: false,
        	visibletosubjectoptions: [
        		{
        			value: 'never',
        			caption: this.$t('never')
        		},
        		{
        			value: 'submit',
        			caption: this.$t('after-submission')
        		},
        		{
        			value: 'review',
        			caption: this.$t('after-review')
        		},
        		{
        			value: 'signoff',
        			caption: this.$t('after-signoff')
        		}
        	]
        }
    },
    methods: {
    	save() {

        	const data = {
        		formtype_settings: this.formtype
			}

			if(this.formtype_id) {
				data.formtype_id = this.formtype_id;
			}

  			this.$cfetch(`${this.$settings.APIBaseURL}/formtypes/saveformtype`, {
  				method: 'post',
  				data
  			})
			.then(json => {
				if (json.status == 'SUCCESS') {
					this.formtype_id = json.formtype.id;
					this.saved = true;
					setTimeout(() => {
						this.saved = false;
					}, 5000);
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
    	},
    	getFormType(id) {
  			this.$cfetch(`${this.$settings.APIBaseURL}/formtypes/getformtype/${id}`)
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status == 'SUCCESS') {

					this.formtype = json.formtype;
					this.formtype_id = json.formtype.id;

					if(!this.formtype.programmes) {
						this.formtype.programmes = [];
					}

				}
			}).catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
			});
    	},
    },
    computed: {

  		roleoptions() {
  			const options = [];
  			for(let role of this.$config.getValue('roles')) {
  				options.push({ text: role.name, value: role.id });
  			}
  			return options;
  		}
    },
    mounted() {

    	if(this.$route.params.formtypeid) {
    		this.getFormType(this.$route.params.formtypeid)
    	} else {
    		this.$store.commit("hideBlockingSpinner");
    	}
    }
}
</script>
